import styled from "styled-components";

export const SeccondModalButtons = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
`;
